import { catalogApi } from '../_api';
import { modelInitialState, catalogInitialState } from '../_utils';
import { servicesEnum } from '../_types';

const CODE = 'supplementary';

export default {
  props: {
    items: { type: Array, required: true, default: () => [] },
  },
  data: () => ({
    model: modelInitialState(),
    localCatalog: catalogInitialState(),
  }),
  computed: {
    alreadyAddedServicesIds() {
      return this.items.map((x) => x?.service.id) || [];
    },
    catalog() {
      return {
        ...this.localCatalog,
        services:
          this.localCatalog.services?.filter(
            ({ id }) => !this.alreadyAddedServicesIds.includes(id)
          ) || [],
      };
    },
  },
  watch: {
    'model.service': {
      async handler(value, oldValue) {
        if (value) {
          const { id: serviceId } = value;
          const params = { serviceId };
          let promises = new Array(3).fill(undefined);

          if (
            [
              servicesEnum.Educativo,
              servicesEnum['Servicio para Ciegos'],
              servicesEnum['Servicio para Sordos'],
              servicesEnum['Educación Física Adaptada'],
              servicesEnum['Educación Física Adaptada/Combinada'],
            ].includes(serviceId)
          ) {
            promises[0] = catalogApi.modalities(CODE, params);
            promises[1] = catalogApi.durations(CODE, params);
          }

          const [modalities = [], durations = []] = await Promise.all(promises);
          this.localCatalog.modalities = modalities;
          this.localCatalog.durations = durations;
        }

        if (oldValue) {
          // manually clean all properties except id and services (to avoid circular watching)
          this.model.other = null;
          this.model.modality = null;
          this.model.frequency = null;
          this.model.duration = null;
          this.model.dutyTime = null;
          this.model.approach = null;
          this.model.teacher = null;
          this.model.equipment = null;
          this.model.place = null;
        }
      },
      deep: true,
    },
    'model.modality': {
      async handler(value, oldValue) {
        if (value) {
          const serviceId = this.model.service?.id;
          const modalityId = value?.id;

          if (serviceId) {
            const approaches = await catalogApi.approaches({
              serviceId,
              modalityId,
            });

            this.localCatalog.approaches = approaches;
          } else {
            this.localCatalog.approaches = [];
          }
        }

        if (oldValue) {
          this.model.approach = null;
        }
      },
      deep: true,
    },
  },
  async created() {
    const [services, frequencies, teachers, places] = await Promise.all([
      catalogApi.services(CODE),
      catalogApi.frequencies(CODE),
      catalogApi.teachers(CODE),
      catalogApi.places(CODE),
    ]);

    this.localCatalog = {
      ...this.localCatalog,
      services,
      frequencies,
      teachers,
      places,
    };
  },
};
